<template>
    <div class="grid-tab-container">
        <!-- Dashboard Stats -->
        <div class="dashboard-stats">
            <div class="stat-card">
                <div class="stat-icon" style="background: #dbeafe;">
                    <i class="dx-icon-box" style="color: #1e40af;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Total Campanii</div>
                    <div class="stat-value">{{ totalCampaigns }}</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon" style="background: #d1fae5;">
                    <i class="dx-icon-event" style="color: #065f46;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Campanii Active</div>
                    <div class="stat-value">{{ activeCampaigns }}</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon" style="background: #fef3c7;">
                    <i class="dx-icon-money" style="color: #78350f;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Buget Total</div>
                    <div class="stat-value">{{ formatCurrency(totalBudget) }}</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon" style="background: #fed7aa;">
                    <i class="dx-icon-chart" style="color: #92400e;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Media Buget</div>
                    <div class="stat-value">{{ formatCurrency(averageBudget) }}</div>
                </div>
            </div>
        </div>

        <!-- Data Grid -->
        <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsCampaniiMarketing"
            :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'"
            :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-column-lines="false"
            :hover-state-enabled="true" :remote-operations="true" class="grid theme-dependent" @row-click="onRowClick">
            <DxSelection mode="single" />
            <DxPaging :page-size="15" :page-index="1" />
            <DxColumnChooser :enabled="true" />
            <DxSorting mode="multiple" />
            <DxHeaderFilter :visible="false" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSearchPanel :visible="true" placeholder="Caută campanie..." />
            <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />

            <DxGridToolbar>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <DxButton icon="plus" type="success" @click="onAddClick" />
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <DxButton icon="refresh" @click="onRefreshClick" hint="Reîmprospătează" />
                </DxGridToolbarItem>
                <DxGridToolbarItem name="exportButton" />
                <DxGridToolbarItem name="columnChooserButton" />
                <DxGridToolbarItem name="searchPanel" />
            </DxGridToolbar>

            <DxFilterRow :visible="true" />

            <DxColumn data-field="Denumire" />


            <DxColumn data-field="IndustrieNume" caption="Industrie" />
            <DxColumn data-field="StatusNume" caption="Status" />

            <DxColumn data-field="TipCampanieNume" caption="Tip Campanie" />
            <DxColumn data-field="DataStart" caption="Dată Start" data-type="date" format="dd/MM/yyyy" />
            <DxColumn data-field="DataEnd" caption="Dată End" data-type="date" format="dd/MM/yyyy" />

            <DxColumn data-field="Buget" data-type="number" format="#,##0.00" cell-template="budgetTemplate" />
            <template #budgetTemplate="{ data }">
                <div class="currency-cell" v-if="data.value !== null && data.value !== undefined">
                    <span class="currency-value">{{ formatCurrency(data.value) }}</span>
                </div>
                <span v-else>-</span>
            </template>

            <DxColumn data-field="CurentActiv" caption="Activ" cell-template="activeTemplate" />
            <template #activeTemplate="{ data }">
                <div class="status-cell">
                    <span :class="['status-badge', data.value ? 'status-active' : 'status-inactive']">
                        <span class="status-dot"></span>
                        {{ data.value ? 'Activ' : 'Inactiv' }}
                    </span>
                </div>
            </template>

            <DxColumn data-field="Explicatie" :visible="false" />
        </DxDataGrid>

        <!-- Add Popup -->
        <DxPopupAdd v-model:visible="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="700" :height="500">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-add"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare campanie</div>
                            <div class="popup-header-subtitle">
                                Completează informațiile în pașii de mai jos
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nouă
                        </span>
                    </div>
                </div>
            </template>
            <div class="popup-body-modern">
                <DxForm :form-data="formData" :col-count="3" ref="form">
                    <DxFormItem data-field="Denumire" :col-span="3">
                        <DxRequiredRule message="Denumirea este obligatorie" />
                    </DxFormItem>
                    <DxFormItem :label="{ text: 'Industrie' }">
                        <DxDropDownBox v-model:value="sIndustrie" :data-source="dsIndustrii" display-expr="Nume"
                            value-expr="ID" :show-clear-button="true" placeholder="Selectează "
                            content-template="gridContent">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsIndustrii" :columns="['Nume']"
                                        :hover-state-enabled="true" :height="280" :remote-operations="true"
                                        @row-click="onIndustrieRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>
                    <DxFormItem :label="{ text: 'Tip Campanie' }">
                        <DxDropDownBox v-model:value="sTipCampanie" :data-source="dsTipuriCampanii"
                            display-expr="Denumire" value-expr="ID" :show-clear-button="true" placeholder="Selectează "
                            content-template="gridContent">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsTipuriCampanii" :columns="['Denumire']"
                                        :hover-state-enabled="true" :height="280" :remote-operations="true"
                                        @row-click="onTipCampanieRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>
                    <DxFormItem data-field="Buget" editor-type="dxNumberBox" :editor-options="bugetEditorOptions">
                        <DxRequiredRule message="Bugetul este obligatoriu" />
                    </DxFormItem>
                    <DxFormItem data-field="DataStart" editor-type="dxDateBox" :editor-options="dateEditorOptions">
                        <DxRequiredRule message="Data de start este obligatorie" />
                    </DxFormItem>
                    <DxFormItem data-field="DataEnd" editor-type="dxDateBox" :editor-options="dateEditorOptions">
                        <DxRequiredRule message="Data de sfârșit este obligatorie" />
                    </DxFormItem>
                    <DxFormItem data-field="StatusID" editor-type="dxSelectBox" :label="{ text: 'Nou' }"
                        :editor-options="{
                            dataSource: dsStatusuri,
                            displayExpr: 'Nume',
                            valueExpr: 'ID',
                            readOnly: true,
                            hoverStateEnabled: false,
                            placeholder: 'Nou'
                        }">
                        <DxLabel text="Status Campanie" />
                    </DxFormItem>
                    <DxFormItem data-field="Explicatie" editor-type="dxTextArea" :col-span="3"
                        :editor-options="explicatieEditorOptions">
                        <DxLabel text="Explicație" />
                    </DxFormItem>
                </DxForm>
                <div class="form-footer footer-modern">
                    <div class="footer-right">
                        <DxButton text="Salvează" type="success" @click="onSaveAdd" styling-mode="outlined" width="100"
                            height="32" />
                        <DxButton text="Anulează" type="danger" @click="isModalVisible = false" styling-mode="outlined"
                            width="100" height="32" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>
    </div>
</template>

<script lang="ts">
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { defineComponent } from 'vue';
import {
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxHeaderFilter,
    DxLoadPanel,
    DxSearchPanel,
    DxExport,
    DxToolbar as DxGridToolbar,
    DxItem as DxGridToolbarItem,
    DxFilterRow,
    DxScrolling
} from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxForm, DxSimpleItem as DxFormItem, DxRequiredRule, DxLabel } from 'devextreme-vue/form';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import CrmCampaniiMarketing from '@/services/Comercial/CrmCampaniiMarketing';
import notify from 'devextreme/ui/notify';

export default defineComponent({
    components: {
        DxDataGrid, DxSelection, DxPaging, DxColumn, DxColumnChooser, DxSorting, DxHeaderFilter, DxLoadPanel, DxSearchPanel, DxExport, DxGridToolbar, DxGridToolbarItem, DxFilterRow,
        DxButton, DxPopupAdd, DxForm, DxFormItem, DxRequiredRule, DxLabel, DxDropDownBox, DxScrolling
    },
    emits: ['select-campaign'],
    data() {
        return {
            dsIndustrii: null as any,
            dsCampaniiMarketing: null as any,
            dsTipuriCampanii: null as any,
            dsStatusuri: null as any,
            sIndustrie: null,
            sTipCampanie: null,
            bugetEditorOptions: {
                format: '#,##0.00'
            },
            dateEditorOptions: {
                displayFormat: 'dd/MM/yyyy'
            },
            explicatieEditorOptions: {
                height: 80
            },
            isModalVisible: false,
            isIndustrieGridBoxOpened: false,
            isTipCampanieGridBoxOpened: false,
            formData: {
                Denumire: '',
                IndustrieID: null,
                StatusID: null,
                TipCampanieID: null,
                DataStart: null,
                DataEnd: null,
                Buget: 0,
                CurentActiv: true,
                Explicatie: ''
            },
            totalCampaigns: 0,
            activeCampaigns: 0,
            totalBudget: 0,
            averageBudget: 0,
            isCalculating: false
        };
    },
    methods: {
        createODataContext() {
            this.dsCampaniiMarketing = new DataSource({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
                    key: 'ID',
                    version: 4,
                    beforeSend: (e) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                        };
                        e.params.$expand = "Industrie($select=Nume)";

                    },
                }),
                onChanged: () => {
                    this.calculateStatistics();
                }
            });
            this.dsIndustrii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Industrii',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
            this.dsTipuriCampanii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Nom_TipCampanii',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Denumire',
                ],

            });
            this.dsStatusuri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_StariOportunitati',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
        },
        onIndustrieRowClick(e) {
            this.isIndustrieGridBoxOpened = false;

            if (e.data) {
                this.sIndustrie = e.data.ID;
                this.formData.IndustrieID = e.data.ID;
            } else {
                this.sIndustrie = null;
            }
        },
        onTipCampanieRowClick(e) {
            this.isTipCampanieGridBoxOpened = false;

            if (e.data) {
                this.sTipCampanie = e.data.ID;
                this.formData.TipCampanieID = e.data.ID;
            } else {
                this.sTipCampanie = null;
            }
        },
        calculateStatistics() {
            if (this.isCalculating) return;

            // Delayed execution to allow data source to fully stabilize
            setTimeout(() => {
                const dataSource = this.dsCampaniiMarketing as any;
                if (dataSource && dataSource.isLoaded()) {
                    const items = dataSource.items();
                    const total = dataSource.totalCount() > 0 ? dataSource.totalCount() : items.length;
                    const active = items.filter((i: any) => i.CurentActiv).length;
                    const budget = items.reduce((acc: number, curr: any) => acc + (curr.Buget || 0), 0);
                    const avg = total > 0 ? budget / total : 0;

                    // Only update if values changed to prevent infinite loops
                    if (this.totalCampaigns !== total ||
                        this.activeCampaigns !== active ||
                        this.totalBudget !== budget ||
                        this.averageBudget !== avg) {

                        this.isCalculating = true;
                        this.totalCampaigns = total;
                        this.activeCampaigns = active;
                        this.totalBudget = budget;
                        this.averageBudget = avg;

                        this.$nextTick(() => {
                            this.isCalculating = false;
                        });
                    }
                }
            }, 50);
        },
        formatCurrency(value: number): string {
            return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(value);
        },
        onRowClick(e: any) {
            this.$nextTick(() => {
                this.$emit('select-campaign', e.data);
            });
        },
        onAddClick() {
            this.formData = {
                Denumire: '',
                IndustrieID: null,
                StatusID: 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9', // Status "Nou" setat default
                TipCampanieID: null,
                DataStart: new Date(),
                DataEnd: new Date(),
                Buget: 0,
                CurentActiv: true,
                Explicatie: ''
            };
            this.sIndustrie = null;
            this.sTipCampanie = null;
            this.isModalVisible = true;
        },
        onRefreshClick() {
            (this.$refs.dataGrid as any).instance.refresh();
        },
        onSaveAdd() {
            const validation = (this.$refs.form as any).instance.validate();
            if (validation.isValid) {
                CrmCampaniiMarketing.save(this.formData).then(() => {
                    notify('Campania a fost adăugată cu succes!', 'success', 2000);
                    this.isModalVisible = false;
                    this.onRefreshClick();
                }).catch(err => {
                    console.error(err);
                    notify('Eroare la salvarea campaniei!', 'error', 2000);
                });
            }
        }
    },
    mounted() {
        this.createODataContext();
    }
});
</script>

<style scoped lang="scss">
.grid-tab-container {
    padding: 1rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.dashboard-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1.5rem;

    .stat-card {
        background: white;
        border-radius: 12px;
        padding: 1.5rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

        .stat-icon {
            width: 48px;
            height: 48px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
        }

        .stat-content {
            .stat-label {
                color: #6b7280;
                font-size: 0.875rem;
                font-weight: 500;
            }

            .stat-value {
                color: #111827;
                font-size: 1.25rem;
                font-weight: 700;
            }
        }
    }
}

.title-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #1e40af;
    font-weight: 600;

    i {
        font-size: 1rem;
    }
}

.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;

    .status-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    &.status-active {
        background: #d1fae5;
        color: #065f46;

        .status-dot {
            background: #059669;
        }
    }

    &.status-inactive {
        background: #f3f4f6;
        color: #374151;

        .status-dot {
            background: #6b7280;
        }
    }
}


/* HEADER POPUP */
.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.popup-header-meta {
    display: flex;
    align-items: center;
}

/* Status Chips */
.status-chip {
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);

    &--open {
        background: #e0f2fe;
        color: #0369a1;
        border-color: #bae6fd;
    }

    &--won {
        background: #dcfce7;
        color: #15803d;
        border-color: #bbf7d0;
    }

    &--lost {
        background: #fee2e2;
        color: #b91c1c;
        border-color: #fecaca;
    }
}

.status-chip--draft {
    background-color: rgba(255, 255, 255, 0.18);
}


.form-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
    margin-top: 1rem;

    .footer-right {
        display: flex;
        gap: 0.5rem;
    }
}
</style>
